class SortorDirective
  constructor: ()->                
    class Sortor
      require: ['^?restfulResources', '^?collectionResources']
      link: ($scope, $element, $attrs, controllers)->        
        controller = controllers[0] ? controllers[1]
        sorting = controller.sorting;        
        $element.append('<i class="sorter-icon fa fa-sort"/>')
        field = $attrs.field        
        @updateUI($element, field, controller)
        $element.click ()=>          
          if field in sorting
            idx = sorting.indexOf field
            sorting[idx] = "-#{field}"
          else if "-#{field}" in sorting
            idx = sorting.indexOf "-#{field}"
            sorting.splice(idx, 1)
          else
            sorting.push field
          controller.sort()
          @updateUI($element, field, controller)
      updateUI: ($element, field, controller)->
        sorting = controller.sorting
        $element.find('.sorter-icon').removeClass('fa-sort fa-sort-asc fa-sort-desc')
        if field in sorting
          $element.find('.sorter-icon').addClass 'fa-sort-asc'                    
        else if "-#{field}" in sorting
          $element.find('.sorter-icon').addClass 'fa-sort-desc'                  
        else
          $element.find('.sorter-icon').addClass 'fa-sort'
    return new Sortor()

  
module.exports = SortorDirective


// WEBPACK FOOTER //
// ./src/common/resource/sortor/index.coffee